import alert from './alert'
import session from './session'

const fields = {
  ...alert,
  ...session
}

export default fields
